import styled, { css } from 'styled-components';
import { em } from '../../styles';
import { typographyStyle } from '../../components/_shared/Typography';
import { Link } from '../../components/_shared/Link';

export const Container = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  padding: 20px;
  justify-content: center;
`;

export const Table = styled.table`
  width: 100%;
`;

export const TableHeader = styled.th`
  text-align: left;
  padding-left: 0.625em;
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #ccc;
`;

export const TableCell = styled.td``;
